import {
  TEST_RUNS_FETCH_REQUEST,
  TEST_RUNS_FETCH_SUCCESS,
  TEST_RUNS_FETCH_FAILURE,
  TEST_RUN_FETCH_REQUEST,
  TEST_RUN_FETCH_SUCCESS,
  TEST_RUN_FETCH_FAILURE,
  TEST_RUN_CLEANUP_REQUEST,
  TEST_RUN_CLEANUP_SUCCESS,
  TEST_RUN_CLEANUP_FAILURE,
  TEST_SPEED_FETCH_SUCCESS,
  TEST_SPEED_UPDATE_SUCCESS,
  TEST_PROGRAMS_FETCH_SUCCESS,
} from '../../types';

export interface ITestManagementState {
  testRuns: any[];
  currentRun: any | null;
  testPrograms: any[];
  loading: boolean;
  cleaningUp: boolean;
  error: string | null;
  speedMultiplier: number;
}

const initialState: ITestManagementState = {
  testRuns: [],
  currentRun: null,
  testPrograms: [],
  loading: false,
  cleaningUp: false,
  error: null,
  speedMultiplier: 1.0,
};

export default function testManagementReducer(
  state = initialState,
  action: any
): ITestManagementState {
  switch (action.type) {
    case TEST_RUNS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case TEST_RUNS_FETCH_SUCCESS:
      return { ...state, loading: false, testRuns: action.payload || [] };
    case TEST_RUNS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case TEST_RUN_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case TEST_RUN_FETCH_SUCCESS:
      return { ...state, loading: false, currentRun: action.payload };
    case TEST_RUN_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case TEST_RUN_CLEANUP_REQUEST:
      return { ...state, cleaningUp: true, error: null };
    case TEST_RUN_CLEANUP_SUCCESS:
      return { ...state, cleaningUp: false };
    case TEST_RUN_CLEANUP_FAILURE:
      return { ...state, cleaningUp: false, error: action.payload };

    case TEST_SPEED_FETCH_SUCCESS:
    case TEST_SPEED_UPDATE_SUCCESS:
      return { ...state, speedMultiplier: action.payload?.speedMultiplier || 1.0 };

    case TEST_PROGRAMS_FETCH_SUCCESS:
      return { ...state, testPrograms: action.payload || [] };

    default:
      return state;
  }
}
